import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { motion } from 'framer-motion'

const Loading = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.background.default,
      }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{
          scale: 1,
          opacity: 1,
          transition: {
            duration: 0.5,
          },
        }}
      >
        <Box sx={{ position: 'relative', width: 80, height: 80 }}>
          {/* Glowing Circle */}
          <motion.div
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              border: `1px solid ${theme.palette.primary.main}`,
              boxShadow: `0 0 15px ${theme.palette.primary.main}`,
            }}
            animate={{
              rotate: 360,
              boxShadow: [
                `0 0 15px ${theme.palette.primary.main}`,
                `0 0 25px ${theme.palette.primary.main}`,
                `0 0 15px ${theme.palette.primary.main}`,
              ],
            }}
            transition={{
              rotate: {
                duration: 3,
                ease: 'linear',
                repeat: Infinity,
              },
              boxShadow: {
                duration: 2,
                ease: 'easeInOut',
                repeat: Infinity,
              },
            }}
          />

          {/* Pulsating Bullet */}
          <motion.div
            style={{
              width: 12,
              height: 12,
              backgroundColor: theme.palette.primary.main,
              borderRadius: '50%',
              position: 'absolute',
              top: '45%',
              left: '42%',
              transform: 'translate(-50%, -50%)',
            }}
            animate={{
              scale: [1, 1.5, 1],
              opacity: [1, 0.5, 1],
            }}
            transition={{
              duration: 1.5,
              ease: 'easeInOut',
              repeat: Infinity,
            }}
          />
        </Box>
      </motion.div>

      {/* Loading Text */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{
          opacity: 1,
          y: 0,
          transition: {
            delay: 0.3,
            duration: 0.5,
          },
        }}
      >
        <Box
          sx={{
            mt: 3,
            typography: 'body1',
            fontWeight: 500,
            color: theme.palette.primary.main,
            background: theme.palette.gradient.primary,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Loading...
        </Box>
      </motion.div>
    </Box>
  )
}

export default Loading
